import { Link } from 'react-router-dom';
import FadeIn from '../components/FadeIn';

function NotFound() {
  return (
    <>
      <title>Page Not Found - vidi3D</title>
      <meta name="robots" content="noindex" />
      
      <div className="flex flex-col items-center justify-center min-h-[80vh] p-8 bg-gray-50">
        <FadeIn>
          <h1 className="text-8xl font-bold text-brand mb-6 drop-shadow-lg">404</h1>
        </FadeIn>
        
        <FadeIn delay={0.2}>
          <h2 className="text-3xl text-brand-dark mb-8 font-semibold">Oops! Page Not Found</h2>
        </FadeIn>
        
        <FadeIn delay={0.4}>
          <p className="text-gray-600 text-center max-w-lg mb-8 text-lg leading-relaxed">
            We're sorry, but it seems like you've ventured into uncharted territory. The page you're looking for might have been moved, deleted, or never existed in the first place. Don't worry though - we'll help you find your way back!
          </p>
        </FadeIn>
        
        <FadeIn delay={0.6}>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to="/" 
              className="bg-brand text-white px-8 py-4 rounded-lg hover:bg-brand-dark transition-all duration-300 transform hover:scale-105 shadow-md text-lg font-medium"
            >
              Return to Homepage
            </Link>
            <Link 
              to="/contact" 
              className="bg-white text-brand px-8 py-4 rounded-lg hover:bg-gray-100 transition-all duration-300 border-2 border-brand transform hover:scale-105 shadow-md text-lg font-medium"
            >
              Contact Support
            </Link>
          </div>
        </FadeIn>
      </div>
    </>
  );
}

export default NotFound;